import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "種類",
    isNumber: true,
  },
];

export const ThreeHighDiseaseAnalysis = {
  label: "三高疾病分析",
  key: "ThreeHighDiseaseAnalysis",
  path: "Diabetes/ThreeHighDiseaseAnalysis",
  api: "TCS_V_Exam_3H",
  render: (options) => (
    <Diagram.Diabetes.ThreeHighDiseaseAnalysis {...options} />
  ),
  isColSum: true,
  isPercent: true,
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  filterColumns: [{ key: "創建日期", type: "date" }],
  levelColumns,
  columns: [],
};
